import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import NavigationScroll from "layouts/NavigationScroll";
import SignIn from "features/Auth/SingIn";
import ForgotPassword from "features/Auth/forgotPassword";
import MainWrapper from "layouts/MainWrapper";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import MainLayout from "layouts/MainLayout";
import themes from "themes";
import ApprovalRequestListView from "features/ApprovalRequest/ApprovalRequestListView";
import ApprovalRequestAddEditView from "features/ApprovalRequest/ApprovalRequestAddEditView";
import OrganizationListView from "features/Organisation/OrganasationListView";
import OrganizationAddEditView from "features/Organisation/OrganisationAddEditView";
import MyOrganisationView from "features/Organisation/MyOrganisationView";
import AccountSettings from "./features/AccountSettings";
import MyApprovalRequestListView from "features/MyApprovalRequestListView";
const router = createBrowserRouter([
  {
    element: (
      <MainWrapper>
        <Outlet />
      </MainWrapper>
    ),
    children: [
      // Публичные маршруты: вход и восстановление пароля
      {
        element: <PublicRoute />,
        children: [
          { path: "/login", element: <SignIn /> },
          { path: "/", element: <SignIn /> },
          { path: "/forgotPassword", element: <ForgotPassword /> },
        ],
      },
      // Приватные маршруты: только для авторизованных
      {
        element: <PrivateRoute />,
        children: [
          {
            element: <MainLayout />,
            path: "/user",
            children: [
              // Основная страница после входа (можно оставить как дефолт)
              // { path: "", element: <DashboardContainer /> },
              { path: "ApprovalRequest", element: <ApprovalRequestListView /> },
              { path: "ApprovalRequest/addedit", element: <ApprovalRequestAddEditView /> },
              { path: "Organization", element: <OrganizationListView /> },
              { path: "Organization/addedit", element: <OrganizationAddEditView /> },
              { path: "account-settings", element: <AccountSettings /> },
              { path: "MyOrganization", element: <MyOrganisationView /> },
              { path: "MyApprovalRequests", element: <MyApprovalRequestListView /> },
            ],
          },
        ],
      },
      // Глобальные fallback-маршруты (опционально)
      { path: "error-404", element: <div></div> },
      { path: "access-denied", element: <div></div> },
      { path: "*", element: <div>not founded</div> },
    ],
  },
]);

const App = () => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(null)}>
        <CssBaseline />
        <NavigationScroll>
          <RouterProvider router={router} />
        </NavigationScroll>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;